import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function CTAButton({
  children,
  href = '#',
  className = '',
  size = 'lg',
  ...props
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 bg-emerald-600 hover:bg-emerald-500 text-white shadow-[0_0_30px_rgba(22,163,74,0.4)] hover:shadow-[0_0_40px_rgba(22,163,74,0.6)]';
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl w-full md:w-auto'
  };
  const Component = motion.a;
  return <Component href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseClasses} ${sizeClasses[size]} ${className}`} {...props as any} data-id="element-221">
      {children}
    </Component>;
}